const rolesAndPermissions = [
  // {
  //   tabName: "Roles",
  //   page: [],
  //   path: "/roles-and-permissions/roles",
  //   authority: "PORTAL",
  // },
  // {
  //   tabName: "Users",
  //   page: [],
  //   path: "/roles-and-permissions/users",
  //   authority: "PORTAL",
  // },
  {
    tabName: "Role Management",
    page: [],
    path: "/roles-and-permissions/roleManagement/roleManagement",
    authority: "PORTAL",
    rolePermission: "ROLE_PERMISSION",
  },
  {
    tabName: "Edit role #",
    page: [],
    path: "/roles-and-permissions/roleCreate/roleCreate",
    authority: "PORTAL",
    rolePermission: "ROLE_PERMISSION",
    showInSidebar: false,
  },
];

export default rolesAndPermissions;
